import { render } from "./ButtonDarkMode.vue?vue&type=template&id=05ea5e5a"
import script from "./ButtonDarkMode.vue?vue&type=script&lang=js"
export * from "./ButtonDarkMode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__